import { render, staticRenderFns } from "./planEdit.vue?vue&type=template&id=b8546e86&"
import script from "./planEdit.vue?vue&type=script&lang=js&"
export * from "./planEdit.vue?vue&type=script&lang=js&"
import style0 from "./planEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports